import { ValidatorFn } from '@angular/forms'
import {
  ActivityPendingItemsAPIModel,
  QueriesPendingItemsAPIModel,
  StatusCountAPIModel,
  GovernmentBusinessPendingItemsAPIModel,
  UserDashboardAPIModel,
  EntityWiseDataAPIModel
} from './api.model'

export interface Login {
  token: string
}

export interface Login {
  token: string
}

export interface ActivityDashboardModel {
  activityPendingItemsList: ActivityPendingItemsAPIModel
  statusCountMap: StatusCountAPIModel[]
}

export interface GovernmentBusinessDashboardModel {
  governmentBusinessPendingItemsList: GovernmentBusinessPendingItemsAPIModel
  statusCountMap: StatusCountAPIModel[]
}

export interface DashboardModel extends UserDashboardAPIModel {}

export interface EntityWiseDataModel extends EntityWiseDataAPIModel {}

export interface Column {
  name: string
  key: string
  key2?: string
  type: ColumnType
  build: Function
  cssClasses?: string[]
  filter?: {
    key: string
    type: FieldType
    getOptionsList?: Function
    validations?: [
      {
        message: string
        validator: ValidatorFn
        validationType: string
      }
    ]
    showIncludeAndExclude?: boolean
    placeholder?: string
  }
  sortByKey?: string
  anchor?: {
    link: Function
  }
  onClick?: Function
}

export enum ColumnType {
  FLOAT,
  NUMBER,
  DATE,
  STRING,
  HTML
}

export enum FieldType {
  TEXT,
  NUMBER,
  DATE,
  SELECT,
  CHECKBOX,
  TEXT_AUTOCOMPLETE,
  SELECT_TASK_STATUS,
  MULTISELECT
}

export interface QueriesDashboardModel {
  queriesPendingItemsList: QueriesPendingItemsAPIModel
  statusCountMap: StatusCountAPIModel[]
}

export enum AuthType {
  OTP = 'OTP',
  PASSWORD = 'PASSWORD',
  SSO = 'SSO'
}

export enum SSOProvider {
  MICROSOFT
}
